import { useEffect, useState } from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import { emptyUserMetrics, updateUserAttributes, moveNextPage, updateAsyncThumbnailImg } from "../../../../../store/actions/creator/creatorExperienceBuilder";
import { useDispatch, useSelector } from "react-redux";
import { initialUserMetrics } from "../../../../../store/reducers/creator/creatorExperienceBuilder";
import { getSessionParticipantsSuccess } from '../../../../../store/actions/creator/creatorExperienceManager';
import { emptyExperience } from "../../../../../store/actions/experience/experience";
import {useHistory, useLocation} from "react-router-dom";
import { initAnalysisData } from "../../../../../store/actions/creator/analysis";
import UtilService from "../../../../../helper/service";
import roles from "../../../../../helper/roles";
const darkImages = [8, 9, 12, 13, 14, 15, 16, 17, 32, 33, 36, 40, 44, 48, 49, 50, 51, 52, 54, 55, 56, 61, 65, 68, 69, 70];

const useStyles = makeStyles((theme) => ({
  startDateBlack: {
    position: 'absolute',
    fontSize: 34,
    top: '150px',
    fontFamily: 'Spartan-extrabold',
    color: '#212D40',
    textTransform: 'uppercase',
    marginRight: '60px',
    textAlign:'center'
  },
  startDateWhite: {
    position: 'absolute',
    fontSize: 34,
    top: '150px',
    fontFamily: 'Spartan-extrabold',
    color: '#ffffff',
    textTransform: 'uppercase',
    marginRight: '60px',
    textAlign:'center'
  },
  img: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: 480,
    height: 360,
    '@media (max-width: 860px)': {
      width: 306,
      height: 300,
    },
  },
  imgDimension: {
    width: '100%',
    height: 360
  },
  btn: {
    width: 300,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 20,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  creatorMainTitle: {
    marginBottom: 10,
    textAlign: 'center'
  }
}));

function ReelFinish(Props: any) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { sessionCode, asyncCompleted } = userMetrics;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [changeImageDimension, setChangeImageDimension] = useState(false);
  
  const onReStart = () => {
    dispatch(initAnalysisData());
    dispatch(getSessionParticipantsSuccess(null));
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
    if (!!loginUserData) {
      const emptyRequest = {
        temporary_value: initialUserMetrics,
        user_id: loginUserData.user_id,
      };
      dispatch(updateUserAttributes(apolloClient.client, emptyRequest));
      dispatch(moveNextPage(0));
      dispatch(emptyUserMetrics());
      Props.setFieldChange(false);
      let url = `/creator/experience-manager/participants/${sessionCode}`;
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/participants/${sessionCode}`;
      }
      Props.setConfirmationLeavePage(url);
      dispatch(updateAsyncThumbnailImg(null));
      history.push(url);
    }
  };

  useEffect(() => {
    if (userMetrics.stimulusList && userMetrics.stimulusList.length && userMetrics.stimulusList[0].stimulus_status === 'PROCESSING-SENTTOVDO' && userMetrics.stimulusList[0].stimulus_type === "AUDIO") {
      dispatch(updateAsyncThumbnailImg('/assets/icons/experiencebuilder/video-proccesing-tv.svg'))
      setChangeImageDimension(true)
    }
  }, [userMetrics]);

  useEffect(() => {
    dispatch(emptyExperience());
  }, [dispatch]);

  useEffect(() => {
    !asyncCompleted && dispatch(moveNextPage(page - 1));
    UtilService.addHashTag(history, location.pathname, 'created');
  }, []);

  const getHeaderLabelColor = (thumbnail : any) => {
    if (thumbnail) {
      const arrayPieces = thumbnail.split(/[\s/]+/);
      if (darkImages.includes(parseInt(arrayPieces[arrayPieces.length - 1].split('.')[0].split('-')[1]))) {
        return classes.startDateWhite
      } else {
        return classes.startDateBlack
      }
    } else {
      return classes.startDateBlack
    }
  };

  return (
    <div className="creator-main-reel">
      <p className="creator-title mt-65">
        Congratulations. Your Reel is LIVE!
      </p>
      <p className={classes.creatorMainTitle + ' creator-main-reel-title'}>
        {userMetrics.asyncExperienceName}
      </p>
      <Box justifyContent="center" display="flex" style={{position:'relative'}}>
        {/* <img src={asyncThumbnailImg ? asyncThumbnailImg : '/assets/images/placeholder.png'} alt={'img'} className={classes.img + " " + (changeImageDimension ? classes.imgDimension : "")} /> */}
        <img src={'/assets/icons/experiencebuilder/Reel-create-success.svg'} alt={'img'} className={classes.img + " " + (changeImageDimension ? classes.imgDimension : "")} />
        <span className={getHeaderLabelColor('/assets/icons/experiencebuilder/Reel-create-success.svg')}>
        REEL<br />{UtilService.getReelThumbnailDateFormatString(userMetrics.asyncStartDateTime)}
        </span>
      </Box>

      <br />

      <Box mt={3} display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
        <Button color='primary' size='large' className={classes.btn} onClick={onReStart}>
          Start Tracking Participants
        </Button>
      </Box>

    </div>
  )
}

export default ReelFinish;